<app-abstract-dialog class="skip-dialog" [dialogWidth]="'800'"
                     [playButtonActive]="true"
                     [ttsIconState]="ttsIconState"
                     [repeatButtonActive]="repeatButtonActive"
                     (readTextEvent)="readText()"
                     (playAudioEvent)="playAudio()"
                     (closeEvent)="close()">

    <ng-container abstract-header>
        <div *ngIf="!confirmation; then stepOneHeader else stepTwoHeader"></div>
        <ng-template #stepOneHeader>
            <h3 class="abstract-dialog__header__title">{{'GENERAL.SKIP_TO' | translate}}</h3>
        </ng-template>
        <ng-template #stepTwoHeader>
            <mat-icon class="abstract-dialog__header__icon material-icons-round warning">error_outline</mat-icon>
            <h3 class="abstract-dialog__header__title">{{'CONSENT.SKIP_DIALOG_CONFIRMATION.TITLE' | translate }}</h3>
        </ng-template>
    </ng-container>

    <ng-container abstract-content>
        <div *ngIf="!confirmation; then stepOneContent else stepTwoContent"></div>
        <ng-template #stepOneContent>
            <p class="abstract-dialog__content__text"
               [ngClass]="'skip-step'">
                {{'CONSENT.SKIP_DIALOG.DESCRIPTION_MULTIPLE' | translate }}
            </p>
            <ul class="skip-dialog__content__list">
                <li #selectItem *ngFor="let skip of skipTo" tabindex=0 class="skip-dialog__content__list__item"
                    [attr.aria-label]="skip.informationUnitTitle"
                    (keyup)="onKeyUp($event, skip.unitOrder)">
                    <p class="skip-dialog__content__list__item__paragraph"
                       [className]="skip.unitOrder === selectedUnitOrderId ? 'selected' : 'default'"
                       (click)="selectUnit(skip.unitOrder)">
                        {{skip.informationUnitTitle}}
                    </p>
                </li>
            </ul>
        </ng-template>
        <ng-template #stepTwoContent>
            <p class="abstract-dialog__content__text"
               [ngClass]="'confirmation-step'">{{'CONSENT.SKIP_DIALOG_CONFIRMATION.DESCRIPTION' | translate }}</p>
        </ng-template>
    </ng-container>

    <ng-container abstract-footer>
        <div *ngIf="!confirmation; then stepOneFooter else stepTwoFooter"></div>
        <ng-template #stepOneFooter>
            <div class="abstract-dialog__footer__buttons-wrapper">
                <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                    <app-button
                            [cssClasses]="'small outlined outlined__gray-07'"
                            [ariaLabel]="('GENERAL.CANCEL' | translate) + ('GENERAL.BUTTON' | translate)"
                            (buttonClicked)="close()">
                        {{'GENERAL.CANCEL' | translate }}
                    </app-button>
                </div>
                <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                    <app-button
                            [cssClasses]="'small solid__blue-07'"
                            [ariaLabel]="('GENERAL.SKIP' | translate) + ('GENERAL.BUTTON' | translate)"
                            (buttonClicked)="confirm()">
                        {{'GENERAL.SKIP' | translate }}
                    </app-button>
                </div>
            </div>
        </ng-template>
        <ng-template #stepTwoFooter>
            <div class="abstract-dialog__footer__buttons-wrapper">
                <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                    <app-button
                            [cssClasses]="'small outlined outlined__gray-07'"
                            [ariaLabel]="('GENERAL.CANCEL' | translate) + ('GENERAL.BUTTON' | translate)"
                            (buttonClicked)="close()">
                        {{'GENERAL.CANCEL' | translate }}
                    </app-button>
                </div>
                <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                    <app-button
                            [cssClasses]="'small solid__blue-07'"
                            [ariaLabel]="('GENERAL.SKIP' | translate) + ('GENERAL.BUTTON' | translate)"
                            (buttonClicked)="navigateToUnit(selectedUnitOrderId)">
                        {{'GENERAL.SKIP' | translate }}
                    </app-button>
                </div>
            </div>
        </ng-template>
    </ng-container>
</app-abstract-dialog>
